import { render, staticRenderFns } from "./TimeFrame.vue?vue&type=template&id=2c1ab0d8&scoped=true&"
import script from "./TimeFrame.vue?vue&type=script&lang=js&"
export * from "./TimeFrame.vue?vue&type=script&lang=js&"
import style0 from "./TimeFrame.vue?vue&type=style&index=0&id=2c1ab0d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1ab0d8",
  null
  
)

export default component.exports